import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { partDetailsPartConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsPartStack = createStackNavigator();

const PartDetailsPartNavigator = () => {
  return (
    <PartDetailsPartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {partDetailsPartConfig.map(({ Component, name }) => (
        <PartDetailsPartStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsPartStack.Navigator>
  );
};

export { PartDetailsPartNavigator };
